<mat-toolbar-row class="container fx-row fx-main-between fx-cross-center print-fx-hide lt-md-fx-hide">
  <div class="main-menu fx-row print-fx-hide lt-md-fx-hide">
    <a  mat-button [routerLink]="['/home']" class="mat-button" >Home</a>
    <a mat-button [matMenuTriggerFor]="shop" class="mat-button" (click)="openMegaMenu()">Products<mat-icon iconPositionEnd class="caret">arrow_drop_down</mat-icon></a>
    <mat-menu #shop="matMenu" [overlapTrigger]="false" class="app-dropdown mega-menu">
      <div class="fx-row-wrap">
        @for (category of categoriesList| slice:0:5; track category) {
          <div class="p-1 category_menu fx-col">
            <a mat-menu-item [routerLink]="['/products',category.Category]"><b [textContent]="category.Category"></b></a>
            <mat-divider></mat-divider>
            @for (categoryItem of categoriesItemList[category.CategoryId] | slice:0:5; track categoryItem) {
              <a mat-menu-item (click)="navigateProductDetails(categoryItem.ItemID)">{{categoryItem.ProductName}}</a>
            }
            <a class="f-s-12 c-red" mat-menu-item [routerLink]="['products',category.Category]">{{'view_all_products' | translate}}</a>
          </div>
        }
      </div>

    </mat-menu>
    <a  mat-button [matMenuTriggerFor]="pages" class="mat-button">Pages<mat-icon iconPositionEnd class="caret">arrow_drop_down</mat-icon></a>
    <mat-menu #pages="matMenu" [overlapTrigger]="false" class="app-dropdown">
      <a [routerLink]="['/about']" mat-menu-item>About Us</a>
      <a mat-menu-item [routerLink]="['/faq']" >FAQ</a>
      <a mat-menu-item (click)="navigateToContact()">{{"contact_" | translate}}</a>
      @if (!isLoggedIn()) {
        <a mat-menu-item [routerLink]="['/login']">Sign In</a>
      }
    </mat-menu>
    <a routerLinkActive="router-link-active"   mat-button class="mat-button"(click)="navigateToContact()">{{"contact_" | translate}}</a>
    @if (!isLoggedIn()) {
      <a  [routerLink]="['/join']" routerLinkActive="router-link-active"   mat-button class="mat-button">Join</a>
    }
  </div>
</mat-toolbar-row>



